export default function dsClear(){
    // funkce pro vyčištění fronty
    this.dataStack = [];

}